import { Fragment, type JSX } from 'react';

import { HpSharedTopHeroBannerModule } from '../homepage/HpSharedTopHeroBannerModule/HpSharedTopHeroBannerModule.tsx';
import { HpSharedEditorialModule } from '../homepage/HpSharedEditorialModule/HpSharedEditorialModule.tsx';
import { HpSharedFeaturedBannerModule } from '../homepage/HpSharedFeaturedBannerModule/HpSharedFeaturedBannerModule.tsx';

import { type HpDefaultLayout_viewer$data } from './__generated__/HpDefaultLayout_viewer.graphql.ts';

type Homepage = NonNullable<HpDefaultLayout_viewer$data['homepage']>;
type HomepageModules = NonNullable<NonNullable<Homepage['modules']>[0]>;

type Props = {
    componentModule: HomepageModules;
    key: string;
    viewer: HpDefaultLayout_viewer$data;
    isMobile: boolean;
    moduleIndex: number;
    totalModules: number;
    editorialModuleOrder: number;
    isHydrated: boolean;
};

export const defaultComponentModuleMap: Record<string, (payload: Props) => JSX.Element | null> = {
    topHeroBanner: ({ key, componentModule, isMobile, viewer }) => (
        <HpSharedTopHeroBannerModule
            key={key}
            componentModule={componentModule}
            isMobile={isMobile}
            viewer={viewer}
        />
    ),
    editorial: ({ key, componentModule, isMobile, editorialModuleOrder }) => {
        const secondEditorialModule = editorialModuleOrder === 2;
        return secondEditorialModule ? (
            <Fragment key={key} />
        ) : (
            <HpSharedEditorialModule
                key={key}
                componentModule={componentModule}
                isMobile={isMobile}
                editorialModuleOrder={editorialModuleOrder}
            />
        );
    },
    locations: ({ key, isMobile, viewer }) => {
        const bottomBannerModule = viewer.homepage?.modules?.find(
            mod => mod?.type === 'bottomBanner' && mod?.visible !== false
        );
        return bottomBannerModule ? (
            <HpSharedFeaturedBannerModule
                key={key}
                componentModule={bottomBannerModule}
                isMobile={isMobile}
            />
        ) : null;
    },
};
